



























































import { Vue, Component } from 'vue-property-decorator'
import { Nullable, Dictionary } from '@/types/general'
import ShareAPI from '@/util/api/ShareAPI'
import { ResponseStatus } from '@/enum'
import { ShareLinkData } from '@/types/api/share'
import PCrypto from '@/util/crypto/PCrypto'
import { decrypt } from '@/util/crypto/EntryCrypt'
import { EncryptedEntry } from '@/types/entry'
import { UnencryptedContent } from '@/types/crypto'
import { User } from '@/types/user'

import VPage from './VPage.vue'

@Component({ name: 'shared-entry', components: { VPage } })
export default class SharedEntry extends Vue {
    success: Nullable<boolean> = null
    message: string = ''

    entry: Nullable<EncryptedEntry> = null
    content: UnencryptedContent = {}
    sharedBy: Nullable<User> = null

    async mounted(): Promise<void> {
        const { id, key } = this.$route.params
        if (!id || !key) {
            this.success = false
            this.message = 'Invalid URL'
        }

        try {
            const data = await ShareAPI.getSharedData(this.$route.params.id)
            this.success = true
            this.decryptData(key, data)
            this.entry = data.login
            this.sharedBy = data.sharedBy
        } catch (err) {
            this.success = false
            if (err.response && err.response.data && err.response.data.message) {
                this.message = err.response.data.message
            } else {
                this.message = err
            }
        }
    }

    async decryptData(key: string, data: ShareLinkData): Promise<void> {
        // decrypt document key
        const documentKey = PCrypto.AES.decrypt(data.documentKey, key)
        // decrypt content
        const content = PCrypto.AES.decrypt(data.login.content, documentKey)

        if (content) {
            this.content = JSON.parse(content)
        }
    }
}
